// extracted by mini-css-extract-plugin
module.exports = {"middleBox":"Middle_middleBox__1hR9Q","leftBox":"Middle_leftBox__1OxXn","kefutimebox":"Middle_kefutimebox__3dT4l","gold":"Middle_gold__4JRNl","arrow":"Middle_arrow__21cjL"};